import { FieldError } from 'react-hook-form';
import Typography from '@mui/material/Typography';

export default ({ fieldError }: { fieldError?: FieldError }) => {
  return fieldError?.message ? (
    <Typography variant="body1" sx={{ fontSize: '14px', color: '#e4002b' }}>
      {fieldError?.message}
    </Typography>
  ) : null;
};
